export default __webpack_public_path__ + "static/media/slider-midios-2.67bf0ba6.png";